module.exports={Earlier:"이전",New:"신규",newNotification:"새 알림 {newCount}개",newNotifications:"새 알림 {newCount}개",noNotifications:"알림 없음"};